import { Button, Dropdown, Tabs } from "antd";
import type { TabsProps } from "antd/es/tabs";
import AnalysisAgent from "../../components/tabs/analysisAgent";
import SourceTable from "../../components/tabs/sourceTable";
import QAManager from "../../components/tabs/qaManager";
import { useTabsContext } from "../../contexts/tabsContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { FaChevronDown } from "react-icons/fa";
import { useCommonPropertiesContext } from "../../contexts/commonPropertiesContext";
import { ALL_BATCHES } from "../../entities/entities";
import "./tabs.css";
import { onInitializeDropdownWidth } from "../../utils";
import Icon from "../../components/masterComponents/Icon";

const TabsNav = () => {
    const { activeTabKey, setActiveTabKey, setId } = useTabsContext();
    const { currentBatch, setCurrentBatch, dropdownWithBatchRef, setChoosedBatchToQA } = useCommonPropertiesContext();

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            window.scrollTo(0, 0);
        }
    }, [activeTabKey]);

    useEffect(() => {
        const preventScroll = (e) => {
            const dropdowns = document.querySelectorAll('.ant-select-dropdown');
            for (let dropdown of dropdowns) {
                if (dropdown.contains(e.target)) {
                    e.preventDefault();
                    return;
                }
            }
        };
        document.addEventListener('wheel', preventScroll, { passive: false });
        return () => {
            document.removeEventListener('wheel', preventScroll);
        };
    }, [])
    
    useEffect(() => {
        const queryId = searchParams.get("_id");
        const queryBatch = searchParams.get("batch");
        if (queryId && queryBatch) {
            setId(queryId);
            setCurrentBatch(queryBatch);
            setChoosedBatchToQA(queryBatch);
            setActiveTabKey("QAManager");
            navigate("/", { replace: true })
        }
    }, [searchParams]);

    const items: TabsProps['items'] = [
        {
            label: "Analysis Agent",
            key: "AnalysisAgent",
            children: <AnalysisAgent />
        },
        {
            label: "Source Table",
            key: "SourceTable",
            children: <SourceTable />
        },
        {
            label: "QA Manager",
            key: "QAManager",
            children: <QAManager />
        }
    ]

    return (
        <Tabs
            className="tabs-content"
            type="card"
            activeKey={activeTabKey}
            onChange={(key) => { setActiveTabKey(key) }}
            items={items}
            tabBarExtraContent={{
                left: (
                    <>
                        <Dropdown
                            overlayStyle={{ zIndex: 900 }}
                            menu={{
                                items: ALL_BATCHES,
                                onClick: (info) => setCurrentBatch(info.key),
                                selectedKeys: [currentBatch]
                            }}
                            trigger={["click"]}
                        >
                            <Button
                                ref={(el) => onInitializeDropdownWidth(el, dropdownWithBatchRef)}
                                icon={<Icon icon={FaChevronDown} />}
                                className="btn-color"
                                style={{ marginRight: "var(--spacing-xs)", justifyContent: "flex-start" }}
                            >
                                {currentBatch}
                            </Button>
                        </Dropdown>
                    </>
                )
            }}
        />
    )
}

export default TabsNav